export const messages: Record<string, string> = {
  'catalog.product.badge.launch': 'Lançamento',
  'catalog.product.badge.promotion': 'Promoção',
  'catalog.product.badge.novelty': 'Novidade',
  'catalog.product.badge.sample': 'Demonstradores',
  'catalog.product.badge.bazaar': 'Bazar',
  'catalog.product.badge.recommendation': 'Recomendações',
  'catalog.product.badge.combo': 'Combo',
};
export const getFormattedMessage = (id: string) => {
  return messages[id] || '';
};
